import React from 'react';
import { Star } from 'lucide-react';

// "4.8 ★ (12)" over the last 15 rated jobs, plus the reliability figure
export const RatingBadge = ({ score, reliability, testId, className = '' }) => {
  const stars = score?.stars;
  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] font-semibold ${className}`}
          data-testid={testId}>
      <span className="inline-flex items-center gap-1 rounded-full border border-gold bg-cream px-2 py-0.5 text-gold-deep">
        <Star className="h-3 w-3 fill-current" />
        {stars ? `${stars.toFixed(1)} (${score.count})` : 'No ratings yet'}
      </span>
      {reliability?.score !== null && reliability?.score !== undefined && (
        <span className="text-slate-500">{reliability.score}% reliable</span>
      )}
    </span>
  );
};

export default RatingBadge;
